import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthLogout } from "./index"

export const appfolioAPI = createApi({
  reducerPath: "appfolioApi",
  baseQuery: baseQueryWithAuthLogout,
  tagTypes: ["Appfolio", "AppfolioProgress"],
  endpoints: (builder) => ({
    getMappedData: builder.query({
      query: ({ page = 1, limit = 25, search = "" }) => `/buildium-output?page=${page}&limit=${limit}&search=${search}`,
      providesTags: ["Appfolio"],
    }),

    // getMappedDataById: builder.query({
    //   query: ({ page = 1, limit = 25, search = "", id, filter }) => `/buildium-output/get-csv-profiles-by-id/${id}?page=${page}&limit=${limit}&search=${search}&orderBy=${filter?.orderBy || ""}&sortOrder=${filter?.sortOrder || ""}&buildium_sync_status=${filter?.buildium_sync_status || ""}`,
    //   providesTags: ["Appfolio"],
    // }),

    getMappedDataById: builder.query({
      query: ({ page = 1, limit = 25, search = "", id, filterData = {} }) => {
        const params = new URLSearchParams({
          page: page.toString(),
          limit: limit.toString(),
          search,
          ...filterData,
        });

        return `/buildium-output/get-csv-profiles-by-id/${id}?${params.toString()}`;
      },
      providesTags: ["Appfolio"],
    }),


    uploadAppfolioFile: builder.mutation({
      query: (payload) => ({
        url: `/imports`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Appfolio"],
    }),

    deleteAppfolioFile: builder.mutation({
      query: (id) => ({
        url: `/buildium-output/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Appfolio"],
    }),

    // for single rows update  
    updateAppfolioFile: builder.mutation({
      query: ({ id, data }) => ({
        url: `/buildium-output/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Appfolio"],
    }),
    // for multiple rows update 
    updateAppfolioData: builder.mutation({
      query: (data) => ({
        url: `/buildium-output/update-buildium-csv`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Appfolio"],
    }),

    getCsvProfilesData: builder.query({
      query: ({ page = 1, limit = 25, search = "" }) => `/buildium-output/get-csv-profiles?page=${page}&limit=${limit}&search=${search}`,
      providesTags: ["Appfolio"],
    }),

    deleteCsvProfile: builder.mutation({
      query: (id) => ({
        url: `/buildium-output/delete-csv-profiles-by-id/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Appfolio"],
    }),

    replaceImportFile: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/imports/replace/${id}`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Appfolio'],
    }),
    downloadCSVFile: builder.mutation({
      query: ({ id }) => ({
        url: `/buildium-output/get-export-csv/${id}`,
        method: "GET",
      }),
      providesTags: ["Appfolio"],
    }),
    downloadAppfolioOriginal: builder.mutation({
      query: ({ id }) => ({
        url: `/buildium-output/export-appfolio-original/${id}`,
        method: "GET",
      }),
      providesTags: ["Appfolio"],
    }),
    downloadBuildiumPayload: builder.mutation({
      query: ({ id }) => ({
        url: `/buildium-output/export-buildium-payload/${id}`,
        method: "GET",
      }),
      providesTags: ["Appfolio"],
    }),
    deleteBuildiumEntries: builder.mutation({
      query: ({ id }) => ({
        url: `/buildium-output/delete-buildium-entries/${id}`,
        method: "POST",
      }),
      invalidatesTags: ["Appfolio"],
    }),
    getSyncProgress: builder.query({
      query: ({ id }) => `/buildium-output/sync-progress/${id}`,
      providesTags: ["AppfolioProgress"],
    }),
    getErrorSummary: builder.query({
      query: ({ id }) => `/buildium-output/error-summary/${id}`,
      providesTags: ["AppfolioProgress"],
    }),
    refreshMappings: builder.mutation({
      query: ({ id }) => ({
        url: `/buildium-output/refresh-mappings/${id}`,
        method: "POST",
      }),
      invalidatesTags: ["Appfolio", "AppfolioProgress"],
    }),
    getBuildiumProperties: builder.query({
      query: () => `/buildium-output/buildium-properties`,
    }),
    getBuildiumGLAccounts: builder.query({
      query: () => `/buildium-output/buildium-glaccounts`,
    }),
    getAppfolioProperties: builder.query({
      query: () => `/buildium-output/appfolio-properties`,
    }),
    getAppfolioAccounts: builder.query({
      query: () => `/buildium-output/appfolio-accounts`,
    }),
    syncBuildium: builder.mutation({
      query: (id) => ({
        url: `/buildium-output/${id}/sync`,
        method: "POST",
      }),
      invalidatesTags: ["Appfolio"],
    }),
  }),
});

export const {
  useGetMappedDataQuery,
  useUpdateAppfolioFileMutation,
  useUpdateAppfolioDataMutation,
  useUploadAppfolioFileMutation,
  useDeleteAppfolioFileMutation,
  useGetCsvProfilesDataQuery,
  useGetMappedDataByIdQuery,
  useDeleteCsvProfileMutation,
  useReplaceImportFileMutation,
  useSyncBuildiumMutation,
  useDeleteBuildiumEntriesMutation,
  useGetSyncProgressQuery,
  useGetErrorSummaryQuery,
  useRefreshMappingsMutation,
  useGetBuildiumPropertiesQuery,
  useGetBuildiumGLAccountsQuery,
  useGetAppfolioPropertiesQuery,
  useGetAppfolioAccountsQuery,
} = appfolioAPI;
